import React, {Component} from "react";
import {
    View,
    FlatList,
     ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import AdapterListDead from "./adapter/AdapterListDead";
import store from "../../../../redux/store";
import HMButton from "../../../../customviews/HMButton";

let container = null;
export default class ListDeadScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {

            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: ''
        };
        container = this;

        this.props.callserviceActionRefresh();
    }

    state = {
        show: false
    };

    componentWillReceiveProps(propss) {

    }

    async componentDidMount() {
        // let {item} = this.props.route.params
        //
        // let ListNotSendMyApply = await AsyngStorageClass.getASyng(typeExport.ListDeadOffline + global.typeCategory);
        // if (ListNotSendMyApply != null && ListNotSendMyApply.length > 0) {
        //
        //
        // } else {
        //     ListNotSendMyApply = [];
        //
        // }
        // store.dispatch(serviceActionListNotSendMyApply(ListNotSendMyApply))


        this.props.callserviceActionRefresh()


        this.getData(1)


    }

    async getData(page) {
        let {item, searchall, itemParams} = this.props.route.params

        let after = "0000-00-00";

        let paramss = itemParams.searchall ?
            {
                "_operation": typeExport._Registration,
                "searchall": itemParams.searchall,

                "mode": typeExport._AramestanSearch,
                "lang": i18n.locale,
                "token": store.getState().reducerSplashGetAllData.token,
                "page": page,
                "type": itemParams.type,
                //"token_fb": this.props.DataSplashScreen.token_fb,
            }
            : {
                "_operation": typeExport._Registration,
                "searchall": null,

                "mode": typeExport._AramestanSearch,
                "lang": i18n.locale,
                "token": store.getState().reducerSplashGetAllData.token,
                "page": page,


                "todate": itemParams.todate,
                "fromdate": itemParams.fromdate,
                "fathername": itemParams.fathername,
                "name": itemParams.name,
                "family": itemParams.family,
                "type": itemParams.type,
                //"token_fb": this.props.DataSplashScreen.token_fb,
            };
        if (store.getState().reducerSplashGetAllData.Connection) {

            // this.props.callService(this.props.route.params.item.link_url, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListDeadScreen, _GET, page, typeExport._Count, this.props.route.params.item.id)
            //  this.props.callService(typeExport.urlListDeadScreen, `&lang=${i18n.locale}&after=${after}&page=${page}`, typeExport.TypeGetListDeadScreen, _GET, page, typeExport._Count, null)
            this.props.callService(typeExport.urlListDeadScreen, paramss, typeExport.TypeGetListDeadScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // // let data = await AsyngStorageClass.getASyng(`List${this.props.route.params.item.id}`)
            // let data = await AsyngStorageClass.getASyng(global.IdCity +typeExport.ListDead + global.typeCategory)
            // //this.props.callServiceSuccess(data, 0)
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))
            this.props.callserviceActionError("e",this.props.page)
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    render() {
        let {item, data, itemParams} = this.props.route.params


        return (
            <View style={{position: 'relative', flex: 1}}>




                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar
                            menu
                            props={this.props} statusBarTransparent

                            text={itemParams.searchall ? itemParams.searchall : itemParams.name + " " + itemParams.family}
                            //text={i18n.t('ListNews.title')}
                            //text={(data && data.name ? data.name : (data && data.title ? data.title : ''))}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerListDeadScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>

                            <EmptyView empty={this.props.empty}/>
                            <FlatList
                                data={this.props.results}
                                renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }

                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <AdapterListDead item={item} item_parent={this.props.route.params.item}
                                index={index} hiddenModal={this.hiddenModal}/>;
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
          //  ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListDeadScreen, `?type=${this.props.typee}&city=`, TypeGetListDeadScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection) {
            // this.props.callService(urlListDeadScreen, `?type=${this.props.typee}&city=`, TypeGetListDeadScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }
}
